import api from 'api/api';
import React, { useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import CircularProgress from '@mui/material/CircularProgress';
import ImageIcon from '@mui/icons-material/Image';
const MRModal = ({ ismodal, setIsModal, imagingdata }) => {
  const images = imagingdata?.details?.images || [];
  const imageLinks = imagingdata?.details?.image_links || [];
  const [fetchedImage, setFetchedImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(false);

  const fetchImage = async (link) => {
    setLoading(true);
    setFetchError(false);
    try {
      const response = await api.get(
        `/v1/patients/document/by-link?document_link=${encodeURIComponent(link)}`
      );
      if (response.success === true && response.data) {
        const mimeType = response.data?.mime_type?.split(';')[0] || 'image/png';
        const base64 = response.data;
        setFetchedImage(`data:${mimeType};base64,${base64}`);
      } else {
        setFetchError(true);
      }
    } catch (error) {
      console.error('Error fetching image:', error);
      setFetchError(true);
    } finally {
      setLoading(false);
    }
  };

  if (!ismodal || (!images.length && !imageLinks.length)) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="relative bg-white p-4 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-auto">
        <button
          onClick={() => {
            if (fetchedImage || fetchError) {
              setFetchedImage(null);
              setFetchError(false);
            } else {
              setIsModal(false);
            }
          }}
          className="absolute top-2 right-2 text-gray-500 hover:text-black z-10"
        >
          <RxCross2 size={24} />
        </button>

        {loading ? (
          <div className="flex justify-center items-center h-[400px]">
            <CircularProgress />
          </div>
        ) : fetchedImage ? (
          <div className="flex justify-center items-center h-full mt-8">
            <img
              src={fetchedImage}
              alt="Fetched from link"
              className="rounded-lg max-w-full max-h-[80vh] border border-gray-300"
            />
          </div>
        ) : fetchError ? (
          <div className="flex justify-center items-center h-[400px] text-red-600 text-lg font-semibold">
            Image not found.
          </div>
        ) : (
          <>
            <h2 className="text-xl font-bold mb-4">{imagingdata?.details?.title}</h2>

            {images.length > 0 && (
              <img
                src={`data:${images[0][0]};base64,${images[0][1]}`}
                alt="Imaging Primary"
                className="rounded-lg mb-4 max-w-full"
              />
            )}

            {imageLinks.length > 0 && (
              <div>
                <h3 className="font-semibold mb-3">Image Links</h3>
                <div className="grid grid-cols-1 sm:grid-cols-4 md:grid-cols-5 gap-4">
                  {imageLinks.map((item, idx) => (
                    <button
                      key={idx}
                      onClick={() => !loading && fetchImage(item[1])}
                      disabled={loading}
                      className="bg-gray-100 hover:bg-blue-100 text-blue-600 border border-gray-300 rounded p-3 text-left transition-all duration-200 disabled:opacity-50"
                      title={item[1]}
                    >
                      <div className="flex items-center  gap-2">
                       <ImageIcon/>
                        <span className="truncate ">{`page ${idx}`}</span>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MRModal;
